import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  CardMedia,
  Box,
  Chip,
  Stack,
  Divider,
  createTheme,
  ThemeProvider,
  Rating,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RedeemIcon from '@mui/icons-material/Redeem';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const PopupAd = () => {
  const [open, setOpen] = useState(false);
  

  // check in cookies if ad is already shown
  React.useEffect(() => {
    const adShown = document.cookie.split('; ').find(row => row.startsWith('adShown='));
    if (adShown) {
      
      return;
    }
    // expire in 1 hour
    document.cookie = "adShown=true; max-age=3600; path=/";
    setOpen(true);

  }, []);


 

  const handleEnrollClick = () => {
    window.open(
      'https://linkly.link/2Bh5W',
      '_blank',
      'noopener,noreferrer'
    );
   
  };

   const handleClose = () => {
    handleEnrollClick();
    setOpen(false);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        onClick={()=>{}}
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: '2px solid #f50057',
            boxShadow: 5,
            backgroundColor: darkTheme.palette.background.default,
          },
        }}
      >
        <DialogTitle sx={{ position: 'relative', padding: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {/* <RedeemIcon color="secondary" /> */}
            <Typography variant="h6" maxWidth={'90%'} >
              🎁 Limited Time Offer: UAE Corporate Tax Law_ Complete Guide to Compliance & Filing
            </Typography>
            
          </Stack>
   
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: darkTheme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box position="relative" width="100%" mb={2}>
                
            <p>
            Understand UAE Corporate Tax Regulations: Learners will develop a thorough understanding of the UAE’s corporate tax framework, including applicable Tax rates.</p>
            <p>Leverage Tax Incentives and Exemptions in the UAE: Learners will be able to identify and capitalize on available tax incentives and free zone benefits.</p>  
            <p>Analyze the Impact of International Tax Principles on UAE Businesses: Learners will be equipped to analyze how international tax treaties, OECD guidelines.</p>  
            <CardMedia
              component="img"
              image="https://img-c.udemycdn.com/course/750x422/6535773_ebb0_3.jpg"
            
              sx={{ width: '100%', borderRadius: 1, mb: 2 }}
            />
            </Box>
            
            

            <Typography variant="body1" gutterBottom>
            Master UAE Corporate Taxation : Learn Registration, Tax Groups, Free Zone Rules, Transfer pricing & Filing Procedures
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
              <Typography variant="body2" color="textSecondary">
                Instructor: Sijin K Ravi, FCA, CFE, Tax Agent
              </Typography>
              <Rating value={5.0} readOnly precision={0.1} size="small" />
            </Stack>

            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Founder and Managing Partner of RBS Ravis Auditors LLC/RBS Tax Consultants LLC
            </Typography>

            <Typography variant="body2" color="textSecondary">
              🏆 Premium Course on Udemy
            </Typography>

            {/* <Typography variant="body2" color="success.light" sx={{ mt: 0.5 }}>
              📦 Included in Udemy Business Collection
            </Typography> */}

            <Divider sx={{ my: 2, width: '100%' }} />

            <Box display={'flex'} gap={2} alignItems={'center'}>
              <span>Discount Code: </span>
              <Chip
              label="55960A77B380BF80EEB6"
              color="secondary"
              icon={<RedeemIcon />}
              sx={{ fontWeight: 'bold' }}
              onClick={handleEnrollClick}

            />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ flexDirection: 'column', alignItems: 'stretch', gap: 1 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleEnrollClick}
            fullWidth
            sx={{ fontWeight: 'bold' }}
          >
            Enroll Now
          </Button>
          
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default PopupAd;
